import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';

import { selectOffer, selectOfferId } from 'shared/selectors';
import { selectCPDTrapGroup } from 'shared/selectors/abExperiments/selectCPDTrapGroup';

export const useCpdTracking = (isHomeowner?: boolean) => {
  const offer = useSelector(selectOffer);
  const offerId = useSelector(selectOfferId);

  const experimantGroup = useSelector(selectCPDTrapGroup);
  const searcherSource = experimantGroup === 'control' ? 'trapOfferScreenPriceChart' : 'trapOfferScreenPriceBlock';

  const source = isHomeowner ? 'trapOffer' : searcherSource;
  const cpdDealType = isHomeowner ? undefined : 'buy;';

  const products = [
    {
      id: offerId,
      offerType: 'offer',
      position: 1,
    },
  ];

  const trackCPDTrapVisible = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: source,
      action: 'Show_sopr',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDTrapClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: source,
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDModalVisible = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Popup',
      action: 'Open',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDCreateDraftClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Send',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDDetailClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Detail',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDSuccessScreenVisible = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Success',
      action: 'Send',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  const trackCPDGoToChatClick = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'ToChat',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source,
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
          cpdDealType,
        },
      },
    });
  };

  return {
    trackCPDTrapVisible,
    trackCPDTrapClick,
    trackCPDModalVisible,
    trackCPDCreateDraftClick,
    trackCPDDetailClick,
    trackCPDSuccessScreenVisible,
    trackCPDGoToChatClick,
  };
};
